import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    TablePagination,
    Typography,
    useTheme,
    Card,
    CardContent,
    Menu,
    MenuItem,
    Divider,
    Modal,
    Switch
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PathList } from "../../Common/Routes/Path";
import Loader from "../../Common/Loader";
import { apiList } from "../../Common/Api/ApiList";
import AxiosInstance from "../../Common/Api/ApiHelper";
import ErrorToaster from "../../Component/ErrorToaster";
import {DataGrid} from "@mui/x-data-grid";
import dotLogo from "../../Assets/image/dash/dots.svg";
import deleteicon from "../../Assets/image/FAQ/deleteicon.png";
import editIcon from "../../Assets/image/FAQ/Pen.png";
import Logo from "../../Assets/image/dash/logo.svg";
import {toast} from "react-toastify";

const PAGE_SIZE_OPTIONS = [10];

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 330,
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 24,
    p: 4,
};
const PlansScreen = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [totalData, setTotalData] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const fetchPlansData = async (page = 0, pageSize = PAGE_SIZE_OPTIONS[0]) => {
        try {
            let newPage = page * pageSize;
            const response = await AxiosInstance.get(
                `${apiList.PlansList}?count=${newPage}`
            );
            console.log(response.data)
            const formatedData = response?.data?.r?.data?.map((x, i) => ({
                ...x,
                rowid: i + 1,
            }));
            if (formatedData?.length > 0) {
                setData(formatedData);
                setTotalData(formatedData?.total_count ?? formatedData?.length);
            } else {
                if (newPage === 0) {
                    setData([]);
                }
                setTotalData(0);
            }
            setIsLoading(false);
        } catch (error) {
            ErrorToaster(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPlansData(page);
    }, [page]);

    const handlePageChange = (e, newPage) => {
        setPage(newPage);
    };
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // delete stuff
    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleDeleteClick = () => {
        setOpenDeleteDialog(true);
        handleMenuClose();
    };
    const handleConfirmDelete = async () => {
        try {
            setOpenDeleteDialog(false);
            const response = await AxiosInstance.post(apiList?.DeletePlan, {id: selectedRow});
            if (response.data.s === 1) {
                toast.success("Plan deleted successfully");
                await fetchPlansData(page);
            } else {
                toast.error(response.data.m);
            }
        } catch (error) {
            console.error("Failed to delete plan:", error);
        }
    };
    // delete stuff

    const handleFeatureToggle = async (planId) => {
        try {
            const response = await AxiosInstance.post(apiList.SetFeaturedPlan, { id: planId });
            if (response.data.s === 1) {
                toast.success("Plan updated successfully");
                fetchPlansData(page);
            } else {
                toast.error(response.data.m);
            }
        } catch (error) {
            console.error("Failed to update featured plan:", error);
            toast.error("Something went wrong");
        }
    };



    const theme = useTheme();
    const columns = [
        { headerClassName: "super-app-theme--header", field: "rowid", headerName: "Sr.", flex: 0.3, minWidth: 50, headerAlign: "center" },
        { headerClassName: "super-app-theme--header", field: "name", headerName: "Name", flex: 1.5, minWidth: 150, headerAlign: "center" },
        { headerClassName: "super-app-theme--header", field: "price", headerName: "Price", flex: 1, minWidth: 100, headerAlign: "center" },
        { headerClassName: "super-app-theme--header", field: "status", headerName: "Status", flex: 1, minWidth: 100, headerAlign: "center" },
        {
            headerClassName: "super-app-theme--header",
            field: "is_featured",
            headerName: "Featured",
            flex: 0.8,
            minWidth: 120,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <Switch
                    checked={params.row.is_featured}
                    onChange={() => handleFeatureToggle(params.row.id)}
                    color="primary"
                />
            ),
        },
        { headerClassName: "super-app-theme--header", field: "action", headerName: "Action", flex: 1, minWidth: 100, headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            <Button
                                id="basic-button"
                                onClick={(event) => handleMenuClick(event, params.row.id)}
                            >
                                <img src={dotLogo} alt="" srcSet=""/>
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleMenuClose}
                            >
                                <MenuItem onClick={() => handleDeleteClick()}>
                                    <img src={deleteicon} style={{marginRight: "0.5rem"}} alt=""/>
                                    Delete
                                </MenuItem>
                                <Divider sx={{m: "0 7px"}}/>
                                <MenuItem
                                    onClick={() => navigate(`${PathList.EditPlan}/${selectedRow}`)}
                                    sx={{width: "160px"}}
                                >
                                    <img src={editIcon} style={{marginRight: "0.5rem"}} alt=""/> Edit
                                </MenuItem>
                            </Menu>
                        </div>
                    </Box>
                );
            },
        },
    ];

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pb: 0,
                    }}
                >
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{fontSize: "28px"}}
                    >
                        Plans
                    </Typography>
                    <Button
                        onClick={() =>
                            navigate(`${PathList.AddPlan}`)
                        }
                        sx={{
                            background:
                                "linear-gradient(181.45deg, #7AACFF -80.86%, rgba(60, 117, 213, 0.98) 98.77%)",
                            color: "white",
                            textTransform: "none",
                            "&:hover": {
                                background:
                                    "linear-gradient(181.45deg, #7AACFF -80.86%, rgba(60, 117, 213, 0.98) 98.77%)",
                            },
                        }}
                    >
                        + Add Plan
                    </Button>
                </Box>

                <Card style={{marginTop: "10px"}}>
                    <CardContent>
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <Box sx={{ width: "100%", overflowX: "auto" }}>
                                    <Box sx={{ minWidth: 600 }}>
                                        <DataGrid
                                            rows={data}
                                            columns={columns}
                                            disableColumnMenu
                                            disableColumnSorting
                                            hideFooter
                                            disableColumnFilter
                                            disableAutosize
                                            disableColumnResize
                                            getRowId={(row) => row.id}
                                            sx={{
                                                ".MuiDataGrid-cell": { textAlign: "center" },
                                                ".MuiDataGrid-columnHeaderTitle": { fontWeight: "600", color: "white" },
                                                "& .super-app-theme--header": { background: theme.palette.primary.Blend },
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <TablePagination
                                    component="div"
                                    count={totalData}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                    rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                                />
                            </>
                        )}
                    </CardContent>
                </Card>
            </Box>

            {openDeleteDialog && (
                <Modal
                    open={true}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100px",
                            }}
                        >
                            <img src={Logo} alt="Logo" srcSet="" />
                        </Box>

                        <Typography
                            id="modal-modal-description"
                            sx={{ mt: 1, textAlign: "center" }}
                        >
                            Are you sure ?
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                mt: 1,
                                fontSize: "18px",
                            }}
                        >
                            <Button
                                onClick={() => setOpenDeleteDialog(false)}
                                variant="outlined"
                                sx={{ textTransform: "none" }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleConfirmDelete}
                                variant="outlined"
                                sx={{
                                    textTransform: "none",
                                    background: theme.palette.primary.Blend,
                                    color: "#eee",
                                }}
                            >
                                Confirm
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            )}
        </>
    )
}

export default PlansScreen;